import React from 'react'
import {
  View,
  Platform,
  StyleSheet
} from 'react-native';
import { PieChart } from './PieChart'
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

const isSmallMobile = window.innerWidth <= 350;
const isWeb = Platform.OS === 'web';
export class TrackingPieChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      labelWidth: 0
    }
  }


  render() {
    const data = JSON.parse(JSON.stringify(this.props.data));
    delete data.total;
    const result = [];
    Object.keys(this.props.data).forEach(function (key) {
      result.push({ type: key, value: data[key] });
    });
    const pieData = result
      .filter((value) => value.value > 0)
      .map((value, index) => ({
        value: value.value,
        color: value.type === 'burn' ?
          Theme.GREY : value.type === 'build' ?
          Theme.GREY_DARK_MEDIUM : Theme.GREY_DARK,
        key: `pie-${index}`,
      }))

    return (
      <View style={styles.pieChartContainer}>
        <View style={styles.fullWidth}>
          <PieChart radius={defaultScale(85)} strokeWidth={defaultScale(30)} data={pieData} />
        </View>
      </View>
    )
  }
}

const styles = StyleSheet.create({
  pieChartContainer: {
    justifyContent: 'center',
    width: '45%',
    alignItems: 'center',
  },
  pieChart: {
    height: defaultScale(200),
    width: defaultScale(isSmallMobile ? 170 : 200)
  },
  fullWidth: {
    marginLeft: defaultScale(15),
    width: '100%',
    transform: [{ scale: 1 }]
  }
  // total: {
  //   position: 'absolute',
  //   color: 'white',
  //   fontSize: scaleText(46),
  //   fontWeight: '900',
  //   textAlign: 'center'
  // }
});